import { render } from "./RegLayout.vue?vue&type=template&id=5253e2d5&class=true"
import script from "./RegLayout.vue?vue&type=script&lang=js"
export * from "./RegLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__